import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { Overlay } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import {
  MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatAutocompleteModule,
  MatIconModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatTabsModule,
  MatTooltipModule,
  MatIconRegistry,
  MatCardModule,
  MatListModule,
  MatPaginatorModule,
  MatSidenavModule,
  MatSortModule,
  MatTableModule,
  MatDialogModule,
  MatSelectModule,
  MatDatepickerModule,
  MatRadioModule
} from '@angular/material';


const modules = [
  MatAutocompleteModule,
  MatIconModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCheckboxModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatTabsModule,
  MatTooltipModule,
  MatCardModule,
  MatListModule,
  MatPaginatorModule,
  MatSidenavModule,
  MatSortModule,
  MatTableModule,
  MatDialogModule,
  MatSelectModule,
  MatDatepickerModule,
  MatRadioModule
];


export function MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY(overlay: Overlay, platform: Platform) {
  return () => platform.IOS ? overlay.scrollStrategies.block() : overlay.scrollStrategies.reposition();
}


@NgModule({
  imports: [
    HttpClientModule,
    ...modules
  ],
  exports: modules,
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      deps: [Overlay, Platform],
      useFactory: MAT_AUTOCOMPLETE_SCROLL_STRATEGY_FACTORY,
    }
  ]
})
export class AppMaterialModule {
  constructor(
    private _mdIconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer
  ) {
    _mdIconRegistry.registerFontClassAlias('fa', 'fa');
    _mdIconRegistry.addSvgIconSetInNamespace('navaids',
      _sanitizer.bypassSecurityTrustResourceUrl('assets/icons/navaids.svg'));
    _mdIconRegistry.addSvgIconSetInNamespace('services',
      _sanitizer.bypassSecurityTrustResourceUrl('assets/icons/services.svg'));
    _mdIconRegistry.addSvgIconSetInNamespace('airports',
      _sanitizer.bypassSecurityTrustResourceUrl('assets/icons/airports.svg'));
    _mdIconRegistry.addSvgIconSetInNamespace('amenities',
      _sanitizer.bypassSecurityTrustResourceUrl('assets/icons/amenities.svg'));
    _mdIconRegistry.addSvgIconSetInNamespace('activities',
      _sanitizer.bypassSecurityTrustResourceUrl('assets/icons/activities.svg'));
  }
}
